export const CATALOG_AVAILABILITY = [
  'in stock',
  'out of stock',
  'preorder',
  'available for order',
  'discontinued',
] as const;

export type CatalogAvailability = (typeof CATALOG_AVAILABILITY)[number];

export const CATALOG_AVAILABILITY_CHOICES = [
  'in stock',
  'out of stock',
] as const;

export type CatalogAvailabilityChoice =
  (typeof CATALOG_AVAILABILITY_CHOICES)[number];

export function catalogAvailabilityChoice(
  stored: string | null | undefined,
): CatalogAvailabilityChoice {
  return String(stored ?? '').trim().toLowerCase() === 'in stock'
    ? 'in stock'
    : 'out of stock';
}

export const CATALOG_DEFAULT_AVAILABILITY: CatalogAvailability = 'in stock';

export const CATALOG_CURRENCIES = ['INR', 'USD', 'EUR', 'GBP'] as const;

export const CATALOG_DEFAULT_CURRENCY = 'INR';

export const CATALOG_CONDITIONS = [
  'new',
  'refurbished',
  'used_like_new',
  'used_good',
  'used_fair',
] as const;

export type CatalogCondition = (typeof CATALOG_CONDITIONS)[number];

export const CATALOG_DEFAULT_CONDITION: CatalogCondition = 'new';

export const SHOPIFY_PRODUCT_STATUSES = ['active', 'draft', 'archived'] as const;

export type ShopifyProductStatus = (typeof SHOPIFY_PRODUCT_STATUSES)[number];

export const SHOPIFY_DEFAULT_STATUS: ShopifyProductStatus = 'active';


export const WOO_PRODUCT_STATUSES = [
  'publish',
  'draft',
  'pending',
  'private',
] as const;

export type WooProductStatus = (typeof WOO_PRODUCT_STATUSES)[number];

export const WOO_STOCK_STATUSES = [
  'instock',
  'outofstock',
  'onbackorder',
] as const;

export type WooStockStatus = (typeof WOO_STOCK_STATUSES)[number];
